export const disabledCursor = 'not-allowed';
export const disabledOpacity = 0.5;
